
import { combineReducers } from 'redux';

import definition from './definition';
import ui from './ui';

export function getDefinition(state) {
    return state.definition;
}

export function getUi(state) {
    return state.ui;
}

export default combineReducers({
    definition,
    ui
});
